import React from 'react'
import { useViewport } from '../../utils'
import './bookmark-icon.css'

const ButtonBookmarkIcon = ({className}) => {
  const { isMobile } = useViewport()
  const size = isMobile ? '24px' : '30px'

  return (
    <div className={`button-bookmark-icon rounded border h-auto flex justify-center items-center ${className}`} style={{width: size, height: size, borderColor: '#ddd'}}>
      <img src="/images/icons/khub_bookmark_active.svg" alt="bookmark" className="block" />
    </div>
  )
}

export { ButtonBookmarkIcon }
